(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var user_useUser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3262);
/* harmony import */ var sections_Header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5325);
/* harmony import */ var sections_Gallery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2526);
/* harmony import */ var components_Acrylic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9410);
/* harmony import */ var useScrollPosition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(887);











var Filters = function(param) {
    var sort = param.sort, setSort = param.setSort;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Acrylic__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        className: "rounded-full flex flex-row text-xs",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                onClick: function() {
                    return setSort("most-popular");
                },
                className: [
                    "rounded-l-full pl-3 pr-2 py-1 transition-all",
                    sort === "most-popular" ? "bg-slate-800 text-white" : "text-slate-900 hover:bg-slate-900 hover:text-white", 
                ].join(" "),
                children: "Most Popular"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                onClick: function() {
                    return setSort("newest");
                },
                className: [
                    "rounded-r-full pl-2 pr-3 py-1 transition-all",
                    sort === "newest" ? "bg-slate-800 text-white" : "text-slate-900 hover:bg-slate-900 hover:text-white", 
                ].join(" "),
                children: "Newest"
            })
        ]
    });
};
var Home = function() {
    var ref = (0,user_useUser__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), user = ref.data;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("most-popular"), sort = ref1[0], setSort = ref1[1];
    var scrollPosition = (0,useScrollPosition__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var ref2 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__.useQuery)([
        "gradients-".concat(sort)
    ], (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("/api/gradients?sort=".concat(sort));
                case 2:
                    response = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error(response.statusText);
                case 5:
                    _ctx.next = 7;
                    return response.json();
                case 7:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))), status = ref2.status, gradients = ref2.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "w-full max-w-6xl mx-auto py-2 px-1",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sections_Header__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                className: [
                    "z-40 sticky top-8 py-2 flex flex-row justify-between text-sm font-medium rounded-full transition-all",
                    scrollPosition > 10 ? "px-1" : "px-0", 
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Filters, {
                        sort: sort,
                        setSort: setSort
                    }),
                    user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Acrylic__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: "rounded-full px-2 py-1 transition text-slate-900 hover:bg-slate-900 hover:text-white",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/create",
                            children: "Create"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sections_Gallery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                status: status,
                gradients: gradients
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ }),

/***/ 2526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sections_Gallery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./user/useUser.ts + 2 modules
var useUser = __webpack_require__(3262);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Like.tsx
var Like = __webpack_require__(8640);
// EXTERNAL MODULE: ./components/Copy.tsx
var Copy = __webpack_require__(7079);
;// CONCATENATED MODULE: ./components/Thumbnail.tsx





var Thumbnail = function(param) {
    var liked = param.liked, gradient = param.gradient;
    var ref = (0,useUser/* default */.Z)(), user = ref.data;
    var likeStatus = gradient ? liked.includes(gradient.id) ? "liked" : "notLiked" : "unknown";
    var creation = gradient.creations.at(0);
    var creator = creation === null || creation === void 0 ? void 0 : creation.profile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex w-full flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "cursor-pointer group sm:motion-safe:hover:-translate-y-2 md:motion-safe:hover:scale-105 transition",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/gradients/".concat(gradient.id),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 grid-rows-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "aspect-square w-full rounded col-start-1 row-start-1 col-span-1 row-span-1",
                                style: {
                                    background: gradient.style
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "aspect-square w-full rounded -z-10 col-start-1 row-start-1 col-span-1 row-span-1 group-hover:blur transition-all motion-reduce:duration-75",
                                style: {
                                    background: gradient.style
                                }
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium -mb-0.5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/gradients/".concat(gradient.id),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: gradient.name
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-xs",
                                children: [
                                    "by",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/profiles/".concat(creator.id),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: creator.name
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center justify-end gap-0.5",
                        children: [
                            user && /*#__PURE__*/ (0,jsx_runtime.jsx)(Like/* default */.Z, {
                                status: likeStatus,
                                gradient: gradient
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy/* default */.Z, {
                                text: gradient.style || "",
                                message: "Copied ".concat(gradient.name || "gradient", " to clipboard")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Thumbnail = (Thumbnail);

;// CONCATENATED MODULE: ./sections/Gallery/Gallery.tsx



var loadingPulsations = Array.from({
    length: 16
}, function(_, i) {
    return i;
});
var liked = function(user) {
    if (!user || !user.likes) return [];
    return user.likes.map(function(like) {
        return like.gradient || "";
    });
};
var Gallery = function(param) {
    var status = param.status, gradients = param.gradients;
    var ref = (0,useUser/* default */.Z)(), user = ref.data;
    if (status === "error") return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "w-full flex items-center justify-center h-96 font-medium",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Could not load gradients due to an error on the server."
        })
    });
    if (status === "success" && gradients) return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "grid w-full grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-2 md:grid-cols-4 md:gap-3",
        children: gradients.map(function(gradient) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Thumbnail, {
                gradient: gradient,
                liked: liked(user)
            }, gradient.id);
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "grid w-full grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-2 md:grid-cols-4 md:gap-3",
        children: loadingPulsations.map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "flex w-full flex-col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "aspect-square w-full rounded bg-slate-200 mb-8 motion-safe:animate-pulse"
                })
            }, index);
        })
    });
};
/* harmony default export */ var Gallery_Gallery = (Gallery);

;// CONCATENATED MODULE: ./sections/Gallery/index.ts

/* harmony default export */ var sections_Gallery = (Gallery_Gallery);


/***/ }),

/***/ 4339:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function ClipboardCopyIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ClipboardCopyIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 2350:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function HeartIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(HeartIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 8113:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function HeartIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(HeartIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [225,539,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);